var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:['icon', _vm.name],attrs:{"src":_vm.src,"alt":_vm.name,"srcset":_vm.srcset,"align":"top"},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }